<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="code">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="codeType">
                <wbo-single-select-search-control>
                    <wbo-reason-code-type-select-options></wbo-reason-code-type-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'description'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-entity-availability-single-select-search-control></wbo-entity-availability-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="code"></wbo-main-search-column>
        <wbo-single-select-column field="codeType">
            <wbo-reason-code-type-select-options></wbo-reason-code-type-select-options>
        </wbo-single-select-column>
        <wbo-column field="description" [maxWidth]="100"></wbo-column>
        <wbo-actions-search-column>
            <wbo-discontinue-search-action></wbo-discontinue-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
